import React from "react";
import "quill/dist/quill.snow.css";
import EnhancedMomDiary from './EnhancedMomDiary';
import { getSingleMomDiary, deleteDiaryImage } from '../../services'
import Loader from "../../Loader";
import { Redirect } from 'react-router-dom';


class EditmomDiary extends React.Component {
  state = {
    title: "",
    content: "",
    diaryId: "",
    mood:'',
    file:'',
    redirect: false,
    files:'',
    loading: true
  };

  // handleChange = (e) =>{
  //   console.log(e.target.files)
  //   if(e.target.type === "file"){
  //     this.setState({file:e.target.files[0]})
  //   }
  //   else{
  //     this.setState({[e.target.name]:e.target.value})
  //   }
  // }


  // handleDiscard = () => {
  //   this.setState({ title: "", text: "" });
  //   this.props.history.push("/momdiary");
  // };

  componentDidMount() {
    const recordId = this.props.match.params.id;
    // console.log(diaryId)
    // this.setState({ diaryId });
    let data = {
      recordId
    }

    getSingleMomDiary(data)
      .then(({ data }) => {
        console.log(data);

        let files = data.diary.files.map((file, index) => {
          return { fileId: file._id, filename: file.filename, uploaded: true }
        })

        this.setState({ 
          title:data.diary.title, 
          content: data.diary.text,
          mood:data.diary.mood, 
          recordId, 
          files: files,
          loading: false
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  goBack = () => {
    this.setState({
      redirect: true
    })
  }

  deleteImage = async (imageId) => {
    let data = {
      recordId: this.state.recordId,
      imageId
    }
    console.log(imageId);
    const response = await deleteDiaryImage({data});
    
    this.setState(prevState => ({
      files: prevState.files.filter((file) => file.fileId !== imageId)
    }))
  }

  render() {
    // if (this.state.redirect) this.props.history.push("/momdiary");

    if(this.state.loading == true) {
      return ( 
        <Loader />
      )
    }

    if(this.state.redirect == true) {
      return <Redirect to="/personalhealthrecord/momdiary" />
    }

    const { recordId, title, content, mood, files} = this.state
    return (
      <EnhancedMomDiary 
        title={title}
        content={content}
        mood={mood}
        files={files}
        recordId={recordId}
        formType="edit"
        deleteImage={this.deleteImage}
        goBack={this.goBack}
      />
    );
  }
}

export default EditmomDiary;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/MomDiary/EditmomDiary.js